module.exports = __webpack_public_path__ + "static/media/tabularasa.bafab82a.png";